export const getQvctpPopulations = (state) => state.qvctPopulation

